export default {
  "zh-CN": {
    qrLogin: {
      entry: "扫码登录",
      back: "返回我的",
      title: "扫码登录",
      eyebrow: "SECURE DEVICE LOGIN",
      scanTitle: "扫描登录二维码",
      subtitle: "仅具备主播权限的账号可授权配套直播项目登录。",
      cameraReady: "准备打开后置摄像头",
      openingCamera: "正在打开摄像头",
      cameraActive: "对准二维码即可自动识别",
      startCamera: "打开摄像头扫码",
      stopCamera: "关闭摄像头",
      unsupported: "当前浏览器不支持摄像头二维码识别，请更换支持此功能的浏览器。",
      insecure: "摄像头扫码需要 HTTPS 安全连接。",
      permissionDenied: "未获得摄像头权限，请在浏览器设置中允许访问。",
      cameraFailed: "摄像头启动失败，请检查设备或浏览器权限后重试。",
      invalidCode: "这不是有效的 StarLive 登录二维码。",
      processingEyebrow: "SECURE REQUEST CHECK",
      processingTitle: "正在读取登录请求",
      processingTip: "正在验证二维码和登录设备，请稍候。",
      confirmEyebrow: "DEVICE AUTHORIZATION",
      confirmTitle: "确认登录另一台设备",
      confirmTip: "请确认下面的项目和设备由你本人操作。",
      requestFrom: "登录项目",
      device: "设备",
      expires: "授权有效期",
      securityNotice: "确认后，配套项目只会获得你的主播身份、昵称和头像，不会获得密码或 StarLive 登录令牌。",
      approve: "确认授权登录",
      deny: "拒绝登录",
      approved: "登录授权成功",
      approvedTip: "另一台设备正在完成登录，你可以安全关闭此页面。",
      denied: "已拒绝本次登录",
      done: "完成",
      streamerRequired: "只有已开通直播权限的账号可以使用扫码登录。"
    },
    errors: {
      "QR_LOGIN.INVALID_CLIENT": "配套项目身份验证失败。",
      "QR_LOGIN.TOO_MANY_ACTIVE": "待处理的扫码登录请求过多，请稍后重试。",
      "QR_LOGIN.INVALID_TICKET": "登录二维码无效或已失效。",
      "QR_LOGIN.EXPIRED": "登录二维码已过期，请在另一台设备重新生成。",
      "QR_LOGIN.NOT_PENDING": "该登录请求已被处理，请重新生成二维码。",
      "QR_LOGIN.DENIED": "本次登录请求已被拒绝。",
      "QR_LOGIN.CONSUMED": "该登录授权已经使用，不能重复登录。",
      "QR_LOGIN.NOT_APPROVED": "请先使用 StarLive 主播账号扫码确认登录。"
    }
  },
  "en-US": {
    qrLogin: {
      entry: "Scan to sign in",
      back: "Back to profile",
      title: "QR sign-in",
      eyebrow: "SECURE DEVICE LOGIN",
      scanTitle: "Scan the sign-in QR code",
      subtitle: "Only accounts with streamer access can authorize a companion live-streaming app.",
      cameraReady: "Ready to open the rear camera",
      openingCamera: "Opening camera",
      cameraActive: "Point the camera at the QR code",
      startCamera: "Scan with camera",
      stopCamera: "Stop camera",
      unsupported: "This browser does not support camera QR recognition. Use a supported browser.",
      insecure: "Camera scanning requires a secure HTTPS connection.",
      permissionDenied: "Camera access was not granted. Allow it in your browser settings.",
      cameraFailed: "The camera could not start. Check the device and browser permissions, then try again.",
      invalidCode: "This is not a valid StarLive sign-in QR code.",
      processingEyebrow: "SECURE REQUEST CHECK",
      processingTitle: "Checking sign-in request",
      processingTip: "Verifying the QR code and requesting device. Please wait.",
      confirmEyebrow: "DEVICE AUTHORIZATION",
      confirmTitle: "Sign in on another device?",
      confirmTip: "Make sure you recognize the app and device below.",
      requestFrom: "Application",
      device: "Device",
      expires: "Authorization expires",
      securityNotice: "The companion app receives only your scoped streamer identity, display name, and avatar. It never receives your password or StarLive session token.",
      approve: "Authorize sign-in",
      deny: "Deny",
      approved: "Sign-in authorized",
      approvedTip: "The other device is completing sign-in. You can safely close this page.",
      denied: "Sign-in request denied",
      done: "Done",
      streamerRequired: "QR sign-in is available only to accounts with streamer access."
    },
    errors: {
      "QR_LOGIN.INVALID_CLIENT": "The companion application could not be authenticated.",
      "QR_LOGIN.TOO_MANY_ACTIVE": "Too many QR sign-in requests are pending. Try again shortly.",
      "QR_LOGIN.INVALID_TICKET": "This sign-in QR code is invalid or no longer available.",
      "QR_LOGIN.EXPIRED": "This sign-in QR code expired. Generate a new one on the other device.",
      "QR_LOGIN.NOT_PENDING": "This sign-in request has already been handled. Generate a new QR code.",
      "QR_LOGIN.DENIED": "This sign-in request was denied.",
      "QR_LOGIN.CONSUMED": "This authorization was already used and cannot be reused.",
      "QR_LOGIN.NOT_APPROVED": "Scan and approve this request with a StarLive streamer account first."
    }
  },
  "ar-SA": {
    qrLogin: {
      entry: "تسجيل الدخول بالمسح",
      back: "العودة إلى ملفي",
      title: "تسجيل الدخول عبر QR",
      eyebrow: "تسجيل دخول آمن للجهاز",
      scanTitle: "امسح رمز تسجيل الدخول",
      subtitle: "يمكن فقط للحسابات التي تملك صلاحية البث تفويض تطبيق البث المصاحب.",
      cameraReady: "جاهز لفتح الكاميرا الخلفية",
      openingCamera: "جارٍ فتح الكاميرا",
      cameraActive: "وجّه الكاميرا نحو رمز QR",
      startCamera: "المسح بالكاميرا",
      stopCamera: "إيقاف الكاميرا",
      unsupported: "لا يدعم هذا المتصفح قراءة QR بالكاميرا. استخدم متصفحًا يدعم هذه الميزة.",
      insecure: "يتطلب المسح بالكاميرا اتصال HTTPS آمنًا.",
      permissionDenied: "لم يُسمح باستخدام الكاميرا. امنح الإذن من إعدادات المتصفح.",
      cameraFailed: "تعذر تشغيل الكاميرا. تحقق من الجهاز وأذونات المتصفح ثم حاول مجددًا.",
      invalidCode: "هذا ليس رمز تسجيل دخول صالحًا لـ StarLive.",
      processingEyebrow: "التحقق الآمن من الطلب",
      processingTitle: "جارٍ التحقق من طلب تسجيل الدخول",
      processingTip: "جارٍ التحقق من رمز QR والجهاز الطالب. يُرجى الانتظار.",
      confirmEyebrow: "تفويض الجهاز",
      confirmTitle: "تسجيل الدخول على جهاز آخر؟",
      confirmTip: "تأكد من أنك تعرف التطبيق والجهاز أدناه.",
      requestFrom: "التطبيق",
      device: "الجهاز",
      expires: "انتهاء التفويض",
      securityNotice: "يحصل التطبيق المصاحب فقط على هوية بث مقيّدة واسم العرض والصورة، ولا يحصل على كلمة المرور أو رمز جلسة StarLive.",
      approve: "تفويض تسجيل الدخول",
      deny: "رفض",
      approved: "تم تفويض تسجيل الدخول",
      approvedTip: "يكمل الجهاز الآخر تسجيل الدخول. يمكنك إغلاق هذه الصفحة بأمان.",
      denied: "تم رفض طلب تسجيل الدخول",
      done: "تم",
      streamerRequired: "تسجيل الدخول عبر QR متاح فقط للحسابات التي تملك صلاحية البث."
    },
    errors: {
      "QR_LOGIN.INVALID_CLIENT": "تعذرت مصادقة التطبيق المصاحب.",
      "QR_LOGIN.TOO_MANY_ACTIVE": "توجد طلبات QR معلقة كثيرة. حاول بعد قليل.",
      "QR_LOGIN.INVALID_TICKET": "رمز تسجيل الدخول غير صالح أو لم يعد متاحًا.",
      "QR_LOGIN.EXPIRED": "انتهت صلاحية الرمز. أنشئ رمزًا جديدًا على الجهاز الآخر.",
      "QR_LOGIN.NOT_PENDING": "تمت معالجة هذا الطلب بالفعل. أنشئ رمز QR جديدًا.",
      "QR_LOGIN.DENIED": "تم رفض طلب تسجيل الدخول.",
      "QR_LOGIN.CONSUMED": "تم استخدام هذا التفويض ولا يمكن استخدامه مرة أخرى.",
      "QR_LOGIN.NOT_APPROVED": "امسح الطلب ووافق عليه أولًا بحساب بث StarLive."
    }
  }
}
